import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { InputGroup, InputGroupAddon, InputGroupText, Button, Input, Label } from 'reactstrap';

import { CurrentTheme, MagstimColor } from "common";
import { CurrentLang } from 'common/utils/LocalisationUtils';
import MagstimInputGroup from './MagstimInputGroup'

class MagstimInputGroupImage extends MagstimInputGroup {

    state = {
        selectedFile: undefined,
        selectedFileFromPops: undefined,
        ignoreSelectedFileFromPops: false
    };

    static getDerivedStateFromProps(props, state) {

        // Only update when the props are changed and set disabled based on the checked state
        if (state.checkedFromProps !== props.checked) {
            state.checked = props.checked;
            state.disabled = !props.checked;

            state.checkedFromProps = state.checked;
        }

        if(state.ignoreSelectedFileFromPops === false){
            // Only update when the props are changed
            if (state.selectedFileFromPops !== props.selectedFile) {
                state.selectedFile = props.selectedFile;
                state.checkedFromProps = state.selectedFile;
            }
        }
       
        return state;
    }

    onCheckboxChange = () => {
        const newCheckState = !this.state.checked;
        this.setState({ checked: newCheckState, disabled: !newCheckState })

        if (this.props.onSetEnabled !== undefined) {
            this.props.onSetEnabled(this.props.name, newCheckState);
        }
    }

    chooseFile = () => {
        this.onImport();
    }

    clearFile = () => {
        this.clearSelectedFile();
    }

    buildFileSelector() {
        const fileSelector = document.createElement('input');
        fileSelector.setAttribute('type', 'file');
        fileSelector.setAttribute('single', 'single');
        fileSelector.setAttribute('accept', 'image/png, image/jpeg');
        fileSelector.onchange = this.onFileSelected;
        return fileSelector;
    }

    onImport = () => {
        var fileSelector = this.buildFileSelector();
        fileSelector.click();
    }

    onFileSelected = (event) => {

        if (event.target.files.length > 0) {

            const file = event.target.files[0];

            if (file.size > 1024 * 1024) {
                alert(CurrentLang().logo_too_big_message)
            }
            else {
                this.setSelectedFile(event.target.files[0]);
            }
        }
    }

    setSelectedFile(file) {

        const url = URL.createObjectURL(file);

        this.setState({ selectedFile: url }, () => {
            if (this.props.onFileSelected !== undefined) {
                this.props.onFileSelected(file, url)
            }
            if (this.props.onNonFormikInputsTouched !== undefined) {
                this.props.onNonFormikInputsTouched()
            }
        });
    }

    clearSelectedFile() {

        this.setState({ selectedFile: undefined, ignoreSelectedFileFromPops: true }, () => {
            if (this.props.onFileSelected !== undefined) {
                this.props.onFileSelected(undefined, undefined)
            }
            if (this.props.onNonFormikInputsTouched !== undefined) {
                this.props.onNonFormikInputsTouched()
            }
        });
    }

    getSelectedFileUrl() {
        return this.state.selectedFile;
    }

    getImage = () => {
        var image = <></>

        if (this.state.selectedFile !== undefined && this.state.selectedFile !== null && this.state.selectedFile.length > 0) {
            image = <><img src={this.state.selectedFile} alt="" className="upload-image" />
                <Button
                    className="clear-button"
                    color="secondary"
                    onClick={this.clearFile}
                    size={CurrentTheme().ControlSize}
                    disabled={this.props.disabled}>
                    <i className="fas fas fa-trash-alt"></i>
                </Button></>
        }else{
            image = <Label  className="help-text">
                        {CurrentLang().image_upload_help} 
                    </Label>
        }

        return image;
    }

    getCheckBox = () => {
        var checkBox = <></>

        if (this.props.showCheckBox !== undefined && this.props.showCheckBox === true) {
            checkBox = <InputGroupAddon addonType="append" className="magstim-checkbox-container mr-3">
                <Input type="checkbox" className="magstim-checkbox" checked={this.state.checked} onChange={this.onCheckboxChange} />
            </InputGroupAddon>
        }

        return checkBox;
    }

    render() {

        return (
            <Wrapper>
                <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <InputGroup size={CurrentTheme().ControlSize}>
                    <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                        <InputGroupText>{this.props.title}</InputGroupText>
                    </InputGroupAddon>
                    {this.getCheckBox()}
                    {this.getImage()}
                    <Button
                        className="upload-button"
                        color="primary"
                        onClick={this.chooseFile}
                        size={CurrentTheme().ControlSize}
                        disabled={this.props.disabled}>
                        <i className="fas fa-upload"></i> {CurrentLang().upload}
                    </Button>
                </InputGroup>
            </Wrapper>
        );
    }
}

MagstimInputGroupImage.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    touched: PropTypes.bool,
    errors: PropTypes.string,
    disabled: PropTypes.bool,
    selectedFile: PropTypes.string,
    onFileSelected: PropTypes.func,
    onNonFormikInputsTouched: PropTypes.func,
    checked: PropTypes.bool,
    showCheckBox: PropTypes.bool,
};

MagstimInputGroupImage.defaultProps = {
    title: "",
    name: "",
    touched: false,
    errors: undefined,
    disabled: false,
    selectedFile: undefined,
    onFileSelected: undefined,
    onNonFormikInputsTouched: undefined,
    checked: undefined,
    showCheckBox: false
};

const Wrapper = styled.div`

.upload-button{
    max-height:36px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
}

.clear-button{
    margin-right:10px;
    max-height:36px;
}

.upload-image{
    max-width:100px;
    max-height:100px;
    margin-right:10px;
    border: solid 2px ${MagstimColor.MagstimTextBackground};
    border-radius: 4px;
}

.help-text{
    margin-right:10px;
    font-size:12px;
    display: flex;
    align-items: center;
    height:36px;
    margin-bottom:0px;
}

`

export default MagstimInputGroupImage